import { BuildTripViewType } from '@sd-portal/shared/models';

export const getBATRoute = (buildTripViewTypeId: number) => {
  let route = '/pre-flight/schedule/';
  if (buildTripViewTypeId === BuildTripViewType.ByLeg) {
    route = '/pre-flight/schedule-beta/';
  }
  return route;
};
